// housekeeping/styles/styles.js

export const styles = {
    // Container Styles
    container: {
        minHeight: '100vh',
        backgroundColor: '#f9fafb',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },

    // Header Styles
    header: {
        backgroundColor: 'white',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        borderBottom: '1px solid #e5e7eb'
    },
    headerContent: {
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 1rem'
    },
    headerInner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 0'
    },
    headerTitle: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#111827',
        marginBottom: '0.25rem'
    },
    headerSubtitle: {
        color: '#6b7280'
    },
    addBtn: {
        backgroundColor: '#16a34a',
        color: 'white',
        padding: '0.5rem 1rem',
        border: 'none',
        borderRadius: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        cursor: 'pointer',
        fontWeight: '500',
        transition: 'background-color 0.2s'
    },

    // Navigation Styles
    navContainer: {
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 1rem'
    },
    navTabs: {
        display: 'flex',
        gap: '0.25rem',
        marginTop: '1.5rem'
    },
    navTab: {
        padding: '0.5rem 1rem',
        borderRadius: '0.5rem',
        fontWeight: '500',
        textTransform: 'capitalize',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s'
    },
    navTabActive: {
        backgroundColor: '#16a34a',
        color: 'white'
    },
    navTabInactive: {
        backgroundColor: 'white',
        color: '#6b7280'
    },

    // Main Content
    mainContent: {
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '2rem 1rem'
    },

    // Cards and Statistics
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem',
        marginBottom: '2rem'
    },
    statCard: {
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
    },
    statHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    statNumber: {
        fontSize: '1.875rem',
        fontWeight: 'bold',
        marginBottom: '0.25rem'
    },
    statIcon: {
        width: '2rem',
        height: '2rem',
        borderRadius: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    card: {
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
    },
    cardTitle: {
        fontSize: '1.125rem',
        fontWeight: '600',
        color: '#111827',
        marginBottom: '0.5rem'
    },

    // Progress Bar
    progressBar: {
        width: '100%',
        backgroundColor: '#e5e7eb',
        borderRadius: '9999px',
        height: '0.5rem',
        marginBottom: '0.5rem'
    },
    progressFill: {
        backgroundColor: '#16a34a',
        height: '0.5rem',
        borderRadius: '9999px',
        transition: 'width 0.3s'
    },

    // Filter Section
    filterSection: {
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        marginBottom: '1.5rem'
    },
    filterGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem'
    },
    filterInput: {
        width: '100%',
        padding: '0.5rem',
        border: '1px solid #d1d5db',
        borderRadius: '0.5rem',
        fontSize: '0.875rem'
    },

    // Tasks
    tasksGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '1.5rem'
    },
    taskCard: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        padding: '1.5rem'
    },
    taskHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '1rem'
    },
    taskActions: {
        display: 'flex',
        gap: '0.5rem'
    },
    priorityBadge: {
        padding: '0.25rem 0.75rem',
        borderRadius: '0.5rem',
        fontSize: '0.75rem',
        fontWeight: '500',
        color: 'white'
    },
    statusBadge: {
        padding: '0.25rem 0.75rem',
        borderRadius: '9999px',
        fontSize: '0.875rem',
        fontWeight: '500'
    },

    // Workers
    workersGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
        gap: '1.5rem'
    },
    workerCard: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        padding: '1.5rem'
    },
    workerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1.5rem'
    },
    workerInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
    },
    avatar: {
        width: '3rem',
        height: '3rem',
        backgroundColor: '#16a34a',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: '500',
        fontSize: '1.125rem'
    },
    workerStats: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '1rem',
        marginBottom: '1.5rem',
        textAlign: 'center'
    },

    // Modal
    modal: {
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
    },
    modalContent: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        padding: '1.5rem',
        width: '100%',
        maxWidth: '40rem',
        margin: '0 1rem'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem'
    },
// 
    // Forms
    formGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
    formGroup: {
        marginBottom: '0.75rem'
    },
    formLabel: {
        display: 'block',
        fontSize: '0.875rem',
        fontWeight: '500',
        color: '#374151',
        marginBottom: '0.5rem'
    },
    formInput: {
        width: '100%',
        padding: '0.75rem',
        border: '1px solid #d1d5db',
        borderRadius: '0.5rem',
        fontSize: '0.875rem'
    },

    // Buttons
    btnGroup: {
        display: 'flex',
        gap: '0.75rem',
        marginTop: '1.5rem'
    },
    btn: {
        flex: 1,
        padding: '0.5rem 1rem',
        borderRadius: '0.5rem',
        fontSize: '0.875rem',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s'
    },
    btnSecondary: {
        border: '1px solid #d1d5db',
        color: '#374151',
        backgroundColor: 'white'
    },
    btnPrimary: {
        border: 'none',
        backgroundColor: '#16a34a',
        color: 'white'
    }
};